import React, { Component } from "react";
import { Grid, Row, Col, Table, Tooltip, OverlayTrigger } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import CustomButtom from "components/CustomButton/CustomButton.jsx";
import { Link } from "react-router-dom";
import { fetchUsersRequest, deleteUserRequest } from "../../api/user";
import { getFullName } from "../../helpers/functions/employee";

class UserList extends Component {

  state = {
    users: null,
    error: null
  };

  componentDidMount() {
    if (!this.state.users)
      this.fetchUsers()
  }

  fetchUsers(){
    fetchUsersRequest(
      result => this.setState({users: result, error: null}),
      error => this.setState({error: error})
    )
  };

  goToUserDetails = (id) => {
    this.props.history.push(`/users/details/${id}`)
  }

  goToUserEditForm = (id) => {
    this.props.history.push(`/users/edit/${id}`)
  }

  goToUserCreateForm = () => {
    this.props.history.push(`/users/create`)
  }

  deleteUser = (id) => {
    deleteUserRequest(
      id,
      result => this.fetchUsers(),
      error =>
        this.setState({ error: "There was an error deleting instance" })
    );
  }

  render() {

    const { users } = this.state;
    const view = <Tooltip id="view_tooltip">View</Tooltip>;
    const edit = <Tooltip id="edit_tooltip">Edit</Tooltip>;
    const remove = <Tooltip id="remove_tooltip">Remove</Tooltip>;

    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Users"
                category="List of all users"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div>
                    <CustomButtom className="table-top-btn btn-primary" onClick={() => this.goToUserCreateForm()}>
                      New Entry
                    </CustomButtom>
                    <Table striped hover>
                      <thead>
                        <tr>
                          <th>E-mail</th>
                          <th>Role</th>
                          <th>Employee</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                      {users && users.length > 0 
                          ? users.map(user => {
                            return (
                              <tr key={user._id}>
                                <td>{user.email || 'N/A'}</td>
                                <td>{user.role || 'N/A'}</td>
                                <td>
                                  {user.employee ? (
                                    <Link
                                      to={
                                        "/employees/details/" + user.employee._id
                                      }
                                    >
                                      {getFullName(user.employee)}
                                    </Link>
                                  ) : (
                                      "N/A"
                                    )}
                                </td>
                                <td className="td-actions text-right">
                                  <OverlayTrigger placement="top" overlay={view}>
                                    <CustomButtom 
                                      bsStyle="success" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.goToUserDetails(user._id)}
                                    >
                                      <i className="fa fa-eye" />
                                    </CustomButtom>
                                  </OverlayTrigger>

                                  <OverlayTrigger placement="top" overlay={edit}>
                                    <CustomButtom 
                                      bsStyle="info" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.goToUserEditForm(user._id)}
                                    >
                                      <i className="fa fa-edit" />
                                    </CustomButtom>
                                  </OverlayTrigger>

                                  <OverlayTrigger placement="top" overlay={remove}>
                                    <CustomButtom 
                                      bsStyle="danger" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.deleteUser(user._id)}
                                    >
                                      <i className="fa fa-times" />
                                    </CustomButtom>
                                  </OverlayTrigger>
                                </td>
                              </tr>
                            )
                          })
                          : (
                            <tr>
                              <td colSpan='5'>There are no users in the database yet.</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </Table>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default UserList;
